import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { globalTranslationKeys } from '../../../../enums';
import { autoPlayBetStore, doBetStore, gameStore, inputValidationStore } from '../../../../store';

export const StartAutoPlay = observer(({ t }) => {
  const {
    isStartAutoPlay,
    isAutoBetAccepted,
    readyForAutoBet,
    isClosAutoBetSender,
    currentRoundsCount,
  } = autoPlayBetStore;
  const localRefIsDoBet = useRef(null);
  const { partnerWageringOdd } = gameStore;
  const { StopAutoplay, StartAutoplay, MinOdd } = globalTranslationKeys;
  const btnText = isStartAutoPlay ? t(StopAutoplay) : t(StartAutoplay);

  const handleAutBetHandler = () => {
    if (!localRefIsDoBet.current) {
      autoPlayBetStore.toggleStartAutoPlayState();
      if (readyForAutoBet && !isAutoBetAccepted) {
        autoPlayBetStore.handleAutoPlayBetSettings();
        doBetStore.doBetSender();
      }
    }
  };

  useEffect(() => {
    if (!localRefIsDoBet.current && inputValidationStore.isClosedAutoBet) {
      localRefIsDoBet.current = inputValidationStore.isClosedAutoBet;
    }
  }, [inputValidationStore.isClosedAutoBet]);

  return (
    <div className='crash-autoplay'>
      <div
        className={`crash-bet-action ${isStartAutoPlay ? 'cancel' : ''} ${
          isClosAutoBetSender ? 'disabled' : ''
        }`}
        onClick={handleAutBetHandler}
        onMouseDown={() => {
          if (localRefIsDoBet.current) {
            localRefIsDoBet.current = false;
          }
        }}
        onKeyDown={(e) => {
          if (isClosAutoBetSender) e.preventDefault();
        }}
      >
        {isClosAutoBetSender && <span className='circle-loader' />}
        <button className='bet-btn' title={btnText}>
          {btnText}
          {!!partnerWageringOdd && <p> {` ${t(MinOdd)} x${partnerWageringOdd}`} </p>}
        </button>
        {currentRoundsCount !== null && (
          <span className='crash-bet-action-count'>{currentRoundsCount}</span>
        )}
      </div>
      <div className='bet-option-btn type-2 sm'>
        <div className='bet-btn-inner' onClick={() => autoPlayBetStore.resetAutoplayData()}>
          <span className='mid-text ui-lib-undo-clear' />
        </div>
      </div>
    </div>
  );
});
